import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/pb/log-in',
    pathMatch: 'full'
  },
  {
    path: '**',
    redirectTo: '/pb/not-found'
  }
];

export const AppRoutingModule = RouterModule.forRoot(routes, {
  useHash: true,
  onSameUrlNavigation: 'reload',
  preloadingStrategy: PreloadAllModules
});
